import { defineStore, storeToRefs } from 'pinia';
import { ref, computed, reactive } from 'vue';
import type { Ref } from 'vue';

type GlobalUIElement = 'SideNav' | 'CityModal' | 'FiltersModal';

export const GlobalUIElements: Record<string, GlobalUIElement> = {
  SideNav: 'SideNav',
  CityModal: 'CityModal',
  FiltersModal: 'FiltersModal'
};

export const useUiStore = defineStore('ui', () => {
  const activeElements: Ref<GlobalUIElement[]> = ref([]);

  const state = reactive({
    isWishlistSidebarOpen: false,
    isLoginModalOpen: false,
    isNewsletterModalOpen: false,
    isProductTicketListOpen: false,
    isCategoryGridView: true,
    isFilterSidebarOpen: false,
    isMobileMenuOpen: false,
    isAuthSidebarOpen: false,
    isLoginComponentVisible: false,
    isRegisterComponentVisible: false,
    isRegisterConfirmationComponentVisible: false,
    isForgotPasswordComponentVisible: false,
    isResetPasswordComponentVisible: false,
    isLogoutComponentVisible: false,
    isCartComponentVisible: false,
    isCartSidebarOpen: false,
  });

  function toggleGlobalUI(element: GlobalUIElement) {
    if (activeElements.value.includes(element)) {
      activeElements.value = activeElements.value.filter((e) => e !== element);
    } else {
      activeElements.value.push(element);
      // if (element === GlobalUIElements.CityModal) {
      //   $gtm.push(formatGtm('listing/CITY_PANEL_OPEN', {
      //     location: route.value.meta.pageType
      //   }));
      // }
    }
  }

  function setGlobalUI(element: GlobalUIElement, isActive: boolean): void {
    if (isActive) {
      activeElements.value.push(element);
    } else {
      activeElements.value = activeElements.value.filter((e) => e !== element);
    }
  }

  function isGlobalUIActive(element: GlobalUIElement): boolean {
    return activeElements.value.includes(element);
  }

  const isMobileMenuOpen = computed(() => state.isMobileMenuOpen);
  const toggleMobileMenu = () => {
    state.isMobileMenuOpen = !state.isMobileMenuOpen;
  };

  const isCartSidebarOpen = computed(() => state.isCartSidebarOpen);
  const isCartComponentVisible = computed(() => state.isCartComponentVisible);

  function openCartSidebar() {
    resetState();
    state.isAuthSidebarOpen = true;
    state.isCartComponentVisible = true;

  }

  const closeCartSidebar = () => {
    state.isAuthSidebarOpen = state.isCartComponentVisible = false;

  };

  function toggleCartSidebar() {
    if (state.isMobileMenuOpen) toggleMobileMenu();

    state.isCartComponentVisible = !state.isCartComponentVisible;
    state.isAuthSidebarOpen = !state.isAuthSidebarOpen;

  }

  function toggleState(key: string, override?: boolean) {
    state[key] = override === undefined ? !state[key] : override;
  }

  function resetState() {
    Object.keys(state).forEach((key) => {
      state[key] = false;
    });
  }

  return {
    activeElements,
    toggleGlobalUI,
    setGlobalUI,
    isGlobalUIActive,
    openCartSidebar,
    isCartSidebarOpen,
    isCartComponentVisible,
    closeCartSidebar,
    isMobileMenuOpen,
    toggleMobileMenu,
    toggleCartSidebar,
    toggleState,
    resetState,
    state
  };
});
